module.exports = __webpack_public_path__ + "static/img/sys-4.2ee183f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sys-4.png
// module id = sxZV
// module chunks = 1